import styled from '@emotion/styled';
import React from 'react';
import {mixinFlexboxColumn} from 'webapp-lib/styling';

import {sum} from '_/utilities';
import {formattedHoursWithUnit} from '_/utilities/temporal';

import {EventAssignmentSummary} from '../types';
import {getTotalEventDurationInHours} from '../utilities/date';

export const Summary = ({
  assignmentSummary,
}: {
  assignmentSummary: EventAssignmentSummary;
}): React.ReactElement => {
  const casusHours = getTotalEventDurationInHours(assignmentSummary.casus);
  const internalHours = getTotalEventDurationInHours(
    assignmentSummary.internal
  );
  const unassignedHours = getTotalEventDurationInHours(
    assignmentSummary.unassigned
  );

  const totalHours = [casusHours, internalHours, unassignedHours].reduce(sum);

  return (
    <StyledSummary>
      <div>
        Mandatsbezogene Stunden <Hours h={casusHours} />
      </div>
      <div>
        Interne Stunden <Hours h={internalHours} />
      </div>
      {unassignedHours > 0 && (
        <div>
          Nicht zugewiesene Stunden <Hours h={unassignedHours} />
        </div>
      )}
      <Total>
        Arbeitsstunden <Hours h={totalHours} />
      </Total>
    </StyledSummary>
  );
};

const Hours = ({h}: {h: number}): React.ReactElement => (
  <StyledHours>{formattedHoursWithUnit(h)}</StyledHours>
);

const StyledSummary = styled.div`
  ${mixinFlexboxColumn};

  padding-top: var(--gutter-medium);
  padding-right: 10px;
  text-align: right;
  gap: 5px;
  align-self: flex-end;
`;

const Total = styled.div`
  border-top: black solid 1px;
  font-weight: bold;
`;

const StyledHours = styled.span`
  padding-left: var(--gutter);
  text-align: right;
`;
